import { graphql } from 'react-apollo'
import { Layout, Input, Table, Form, Button, Divider } from 'antd'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import XLSX from 'xlsx'

import createTrackingMutation from '../graphql/mutations/createTracking'
import hookTrackingMutation from '../graphql/mutations/hookTracking'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item

class ImportTracking extends Component {
  state = {
    data: [],
    loading: false,
  }
  handleFileChange = (event) => {
    const { files } = event.target
    const file = files[0]
    const reader = new FileReader()
    reader.onload = (e) => {
      const f = e.target.result
      const workbook = XLSX.read(f, { type: 'binary' })
      const sheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[sheetName]
      const rows = XLSX.utils.sheet_to_json(worksheet)
      const data = rows.filter(row => !!row['Tracking code']).map(row => ({
        carrier: row['Tracking type'] || 'thaipost', code: row['Tracking code'], labelId: row['Label ID'], recipient: row.Recipient,
      }))
      this.setState({ data })
    }
    reader.readAsBinaryString(file)
  }
  importTrackings = async () => {
    this.setState({ loading: true })
    const { createTracking, hookTracking } = this.props
    const { data } = this.state
    const createTrackingAndSendHook = async (record) => {
      const { data: { createTracking: { record: tracking } } } = await createTracking({ variables: { record } })
      await hookTracking({ variables: { labelId: record.labelId, trackingId: tracking._id } })
    }
    await data.asyncForEach(async (record) => {
      try {
        const { carrier, code, labelId } = record
        await createTrackingAndSendHook({ carrier, code, labelId })
      } catch (err) {
        console.log(err)
      }
    })
    alert('Import Tracking Completed !')
    this.setState({ loading: false })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const { data, loading } = this.state
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    const columns = [
      {
        title: 'Label ID',
        dataIndex: 'labelId',
        key: 'labelId',
      },
      {
        title: 'Tracking',
        dataIndex: 'code',
        key: 'code',
      },
      {
        title: 'Carrier',
        dataIndex: 'carrier',
        key: 'carrier',
      },
      {
        title: 'Recipient',
        dataIndex: 'recipient',
        key: 'recipient',
      },
    ]
    return (
      <Layout>
        <Navbar selected="import:2" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Form>
              <FormItem
                {...formItemLayout}
                label="File"
              >
                {getFieldDecorator('file', {
                  rules: [{ required: true, message: 'Please input excel file!' }],
                })(
                  <Input type="file" onChange={this.handleFileChange} />
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" onClick={this.importTrackings} disabled={data.length === 0} loading={loading}>Import trackings</Button>
              </FormItem>
            </Form>
            <Divider />
            {data.length > 0 ? (
              <div>
                <h2>Preview</h2>
                <Table
                  rowKey="labelId"
                  dataSource={data}
                  columns={columns}
                  pagination={{ pageSize: 20 }}
                  size="small"
                />
              </div>
            ) : null}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
ImportTracking.propTypes = {
  form: PropTypes.shape(),
}
ImportTracking.defaultProps = {
  form: {},
}

export default graphql(hookTrackingMutation, { name: 'hookTracking' })(graphql(createTrackingMutation, { name: 'createTracking' })(Form.create()(ImportTracking)))



// WEBPACK FOOTER //
// ./src/pages/ImportTrackings.js